<template>
<footer class="footer">
  <div class="container footer__container row">
    <div class="footer__company col-xs-12 col-lg-6">
      <div class="logo">
        <svg version="1.1" id="Layer_1" class="logo__svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 384 352" height="352" width="384" style="enable-background:new 0 0 384 352;" xml:space="preserve">
          <g>
						<path class="st1" d="M133.55,223.52c-12.39,0.14-19.29-10.79-14.27-21.27c6.07-12.67,12.88-24.98,19.42-37.41
							c19.88-37.79,39.82-75.55,59.63-113.38c3.19-6.09,7-11.03,14.54-11.15c11.59-0.18,17.96,11.51,12.12,22.76
							c-15.19,29.26-30.59,58.42-45.92,87.61c-11.06,21.05-22.17,42.08-33.2,63.15C142.9,219.49,138.77,223.29,133.55,223.52z"/>
											<path class="st1" d="M290.73,105.89c-1.04,2.7-1.92,5.85-3.4,8.68c-24.49,46.67-49.03,93.31-73.61,139.93
							c-5,9.49-12.55,12.59-20.56,8.69c-7.9-3.84-10.21-12.34-5.4-21.52c24.56-46.94,49.23-93.81,73.82-140.73
							c3.24-6.19,7.74-10.74,15.17-10.09c6.43,0.56,10.99,4.23,12.93,10.64C290.06,102.76,290.3,104.09,290.73,105.89z"/>
											<path class="st1" d="M370.29,37.71c-0.15,3.81-1.49,6.76-3.01,9.64c-22.87,43.58-45.71,87.17-68.66,130.71
							c-5.52,10.47-13.53,13.65-21.63,9.04c-7.69-4.37-9.47-12.43-4.51-21.88c20.59-39.28,41.26-78.51,61.92-117.75
							c3.15-5.98,6.06-12.12,9.7-17.79c3.86-6,10.07-7.37,16.49-5.19C366.77,26.58,369.88,31.6,370.29,37.71z"/>
											<path class="st1" d="M203.27,171.9c-11.05-0.16-17.39-11.01-12.1-21.49c8.53-16.89,17.47-33.58,26.27-50.34
							c14.46-27.53,28.98-55.02,43.38-82.58c3.2-6.12,7.28-11,14.76-10.86c11.02,0.21,17.29,11.28,12.14,21.81
							c-5.82,11.9-12.19,23.52-18.35,35.25c-17.21,32.8-34.47,65.58-51.62,98.41C214.62,168.08,210.48,172.17,203.27,171.9z"/>
											<path class="st1" d="M146.7,40.38c-0.29,0.92-0.64,3.11-1.61,4.97c-23.72,45.26-47.45,90.51-71.34,135.68
							c-3.18,6.02-8.66,9.08-15.57,7.7c-6.42-1.28-10.3-5.53-11.63-12.07c-0.76-3.72,0.41-6.98,2.05-10.1
							c23.65-44.99,47.33-89.96,71.05-134.91c3.68-6.97,9.8-9.4,17.09-7.34C143.86,26.31,147.05,31.74,146.7,40.38z"/>
											<path class="st1" d="M165.48,89.52c-0.61,1.65-1.29,4.28-2.51,6.63c-20.55,39.29-41.17,78.54-61.76,117.8
							c-2.79,5.33-6.59,9.26-13.03,9.57c-12,0.57-18.81-11.32-12.79-22.95c12.67-24.49,25.63-48.83,38.47-73.23
							c7.93-15.07,15.83-30.16,23.81-45.21c3.68-6.94,9.69-9.4,17.06-7.43C161.49,76.5,164.7,81.67,165.48,89.52z"/>
											<path class="st1" d="M360.73,140.95c0.2,3.46-1.45,6.28-2.96,9.15c-11.02,21.01-21.99,42.04-33.1,63.01
							c-5.23,9.87-13.18,13.04-21.04,8.73c-7.95-4.37-9.69-12.52-4.54-22.38c11.24-21.51,22.52-42.98,33.89-64.42
							c3.53-6.65,9.11-10.18,16.69-8.23C356.68,128.6,360.41,133.62,360.73,140.95z"/>
											<path class="st1" d="M53.27,119.74c-10.96-0.25-18.33-10.58-14-19.45c8.76-17.95,18.12-35.61,27.68-53.15
							c3.64-6.67,12.01-8.61,18.36-5.38c7.02,3.57,10.58,11.28,7.03,18.43C83.46,78.09,74,95.69,64.49,113.26
							C62.01,117.83,57.38,119.68,53.27,119.74z"/>
											<path class="st1" d="M254.91,332.19c-2.42,0.01-4.85,0.01-7.27,0.01c-6.59-0.01-10.04-3.3-10.09-9.89
							c-0.07-10.51-0.01-21.01-0.02-31.52c0-6.25,3.27-9.58,9.33-9.86c5.64-0.25,11.36-0.46,16.96,0.12
							c13.81,1.42,22.25,11.92,21.7,26.35c-0.57,14.96-9.17,24.11-23.34,24.78C259.77,332.28,257.34,332.18,254.91,332.19z
							 M253.55,305.97c0,1.89-0.19,3.81,0.05,5.67c0.31,2.5-1.45,5.92,1.76,7.23c3.03,1.24,6.45,0.68,9.35-1.13
							c4.56-2.85,4.79-7.55,4.71-12.19c-0.08-4.52-1.39-8.52-5.94-10.67c-6.74-3.18-9.84-1.25-9.92,6.22
							C253.54,302.72,253.56,304.35,253.55,305.97z"/>
											<path class="st1" d="M117.16,306.55c3.62-4.08,6.04-6.85,8.5-9.59c2.96-3.31,6.34-4.27,9.83-1.03c3.32,3.08,2.41,6.63-0.56,9.14
							c-4.34,3.66-3.58,6.63-0.62,10.86c3.09,4.42,9.89,9.76,2.68,15.11c-7.34,5.44-10.83-1.44-14.07-6.88
							c-0.79-1.32-1.4-3.36-3.38-2.91c-2.24,0.51-2.35,2.63-2.38,4.56c-0.08,5.18-2.92,7.22-7.84,6.85c-5.27-0.39-6.59-3.89-6.59-8.41
							c0-11.87,0-23.73,0-35.6c0-5.05,1.95-8.35,7.56-8.29c5.33,0.05,6.87,3.37,6.86,8.01C117.16,293.74,117.16,299.13,117.16,306.55z"
											/>
											<path class="st1" d="M33.1,280.83c5.41,0,10.82-0.03,16.23,0.02c4.7,0.04,7.95,1.9,7.84,7.13c-0.09,4.81-3.28,7.08-7.51,6.48
							c-8.37-1.19-9.23,3.24-8.85,9.84c0.39,6.74,0.16,13.52,0.02,20.28c-0.11,5.14-2.79,8.08-8.09,8.09c-5.3,0.01-8.01-2.92-8.12-8.06
							c-0.16-7.84-0.3-15.7,0.01-23.53c0.19-4.81-1.19-6.98-6.32-6.56c-5.2,0.43-10.32-0.28-9.97-7.29c0.32-6.46,5.37-6.44,10.14-6.42
							C23.36,280.84,28.23,280.83,33.1,280.83z"/>
											<path class="st1" d="M164.66,316.22c1.79-6.68,2.98-11.63,4.45-16.49c1.23-4.05,3.75-6.85,8.39-5.44
							c4.51,1.37,5.59,5.08,4.24,9.13c-3.74,11.28-7.4,22.61-11.83,33.62c-3,7.46-9.57,10.09-17.4,8.52c-2.93-0.59-5.18-2.01-5.66-4.99
							c-0.56-3.44,1.66-4.9,4.77-5.13c4.39-0.33,4.55-2.53,3.23-6.08c-3.01-8.1-5.69-16.33-8.57-24.47c-1.66-4.69-1.45-8.84,3.99-10.47
							c5.53-1.66,7.65,2.05,9.08,6.66C160.74,305.58,160.93,310.51,164.66,316.22z"/>
											<path class="st1" d="M317.84,317.08c-1.89,0-3.79-0.11-5.67,0.04c-1.99,0.16-5.04-0.72-5.14,2.34c-0.11,3.21,2.65,4.39,5.55,4.76
							c4.09,0.52,7.05-2.42,10.61-3.54c2.93-0.92,5.45-0.63,6.98,2.22c1.41,2.64,0.04,5.08-2.06,6.3c-8.5,4.91-17.71,4.99-26.56,1.72
							c-8.01-2.97-10.95-9.86-10.66-18.24c0.34-9.95,5.94-16.47,16.03-18.43c10.33-2.01,21.23,2.88,24.71,11.09
							c3.2,7.54,0.88,11.31-7.3,11.74C322.17,317.18,320,317.08,317.84,317.08z M312.63,309.84c1.43-1.62,5.74,1.82,5.62-2.91
							c-0.08-3.21-3.01-4.02-5.89-3.99c-3.3,0.03-6.35,1.58-6.09,4.83C306.53,311.11,310.18,308.89,312.63,309.84z"/>
											<path class="st1" d="M74.35,332.73c-13.42,0.02-20.64-6.72-20.65-19.29c-0.01-12.14,7.92-19.67,20.67-19.61
							c12.54,0.06,21.21,8.17,21.04,19.67C95.22,325.68,87.52,332.71,74.35,332.73z M80.21,313.47c-0.26-4.39-0.21-9.71-6.11-9.35
							c-5.43,0.33-5.85,5.43-5.76,9.88c0.08,4.14,0.41,8.7,5.89,8.74C80.47,322.8,79.96,317.67,80.21,313.47z"/>
											<path class="st1" d="M207.92,332.73c-13.04-0.04-20.86-7.37-20.73-19.41c0.13-11.76,8.65-19.62,21.12-19.48
							c12.65,0.14,20.8,7.96,20.65,19.82C228.81,325.86,221.18,332.78,207.92,332.73z M214.41,313.76c-0.21-4.19-0.43-9.38-5.94-9.67
							c-5.59-0.29-6.51,4.89-6.57,9.28c-0.06,4.34,0.39,9.34,6.32,9.33C213.59,322.69,214.15,318.22,214.41,313.76z"/>
											<path class="st1" d="M354.91,322.27c-1.84,3.11-2.96,5.25-4.31,7.23c-2.59,3.82-6.28,4.28-9.9,2.08
							c-3.32-2.01-3.77-5.75-1.45-8.48c5.63-6.65,6.68-12.78,0.59-19.83c-2.6-3.01-0.7-6.19,2.39-8.17c3.3-2.12,6.24-1.23,8.52,1.72
							c1.45,1.88,2.6,4,4.16,6.44c1.39-2.31,2.42-4.17,3.6-5.92c2.3-3.42,5.31-4.57,9-2.25c3.64,2.29,4.58,6.08,1.95,9.01
							c-5.52,6.16-5.14,11.41,0.15,17.41c3,3.4,3.43,7.8-1.22,10.34c-4.21,2.29-7.83,0.59-10.15-3.63
							C357.32,326.58,356.4,324.95,354.91,322.27z"/>
											<path class="st1" d="M356.09,189.75c9.28-0.07,17.23,7.7,17.27,16.86c0.04,9.19-7.87,17.03-17.09,16.95
							c-9.19-0.09-16.43-7.18-16.69-16.35C339.32,197.9,346.96,189.81,356.09,189.75z"/>
											<path class="st1" d="M41.08,74.43c-0.18,9.64-7.55,16.56-17.31,16.24c-8.94-0.29-16.28-7.81-16.37-16.76
							C7.3,65.1,15.7,56.83,24.63,56.94C33.72,57.05,41.26,65.07,41.08,74.43z"/>
						</g>
					</svg>
      </div>
			<ul class="footer__socials">
				<li class="footer__social"><a href="https://www.instagram.com/tokyodex/" target="_blank">
					<img src="~/assets/images/instagram-icon.svg" alt="Instagram" height="48" width="48">
				</a></li>
				<li class="footer__social"><a href="https://www.facebook.com/TokyoDex/" target="_blank">
					<img src="~/assets/images/facebook-icon.svg" alt="Facebook" height="48" width="48">
				</a></li>
				<li class="footer__social"><a href="https://www.youtube.com/user/TokyoDex" target="_blank">
					<img src="~/assets/images/youtube-icon.svg" alt="YouTube" height="48" width="48">
				</a></li>
			</ul>
    </div>
    <div class="footer__nav col-xs-12 col-lg-6">
				<ul class="nav__links">
					<li v-for="link in safeLinks" class="nav__link">
						<nuxt-link v-if="link?.href || link?.slug?.current"
							:to="localePath(`${link.href != null ? link.href : '/' + link.slug.current}`)"
						:target="link.target != null ? `_blank` : `_self`">{{ locale === 'en' ? link.text.en : link.text.jp }}</nuxt-link>
					</li>
				<li class="nav__link">
					<strong class="footer__copyright">© {{ new Date().getFullYear() }} TokyoDex Inc. All Rights Reserved</strong>
				</li>
			</ul>
    </div>
  </div>
</footer>
</template>

<script setup>
import { useI18n, useLocalePath } from '#imports'
import { computed } from 'vue'
const { locale } = useI18n()
const localePath = useLocalePath()
const props = defineProps({
  content: Object
})
const safeLinks = computed(() => Array.isArray(props.content) ? props.content : [])
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
  .footer {
    background-color: v.$black;
    margin: 3rem 0 0 0;
    width: 100%;
    .footer__container {
      align-items: center;
      color: v.$white;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 2rem 1rem;
      @include v.respond-to('large') {
        padding: 2rem 3rem;
      }
      .logo {
        margin: 1rem 0;
        padding: 0 1rem 0 0;
        .logo__svg {
          height: 100%;
        }
      }
      .footer__company {
        align-items: center;
        display: flex;
				flex-direction: column;
				justify-content: center;
				@include v.respond-to('large') {
					flex-direction: row;
					justify-content: flex-start;
				}
      }
    }
    &__socials-container {
      display: flex;
      justify-content: flex-start;
      @include v.respond-to('large') {
        justify-content: center;
      }
    }
    &__socials {
      display: flex;
      list-style: none;
      margin: 1rem 0;
      padding: 0;
      @include v.respond-to('large') {
        margin: 0 0 0 2rem;
      }
    }
    &__social {
      a {
        background-color: v.$black;
        border: 0.175rem solid v.$white;
        border-radius: 50%;
        display: block;
        height: 3rem;
        margin: 0 0.5rem;
        padding: 0.5rem;
        width: 3rem;
        img {
          height: 100%;
          width: 100%;
        }
        &:hover {
          background-color: v.$teal;
          border-color: transparent;
        }
      }
      &:first-child {
      a {
          margin: 0 0.5rem 0 0;
        }
      }
    }
    &__nav {
      display: flex;
      flex-direction: column;
      .nav__links {
        margin: 0;
        text-align: center;
        @include v.respond-to('large') {
          margin: 0;
          text-align: right;
        }
        .nav__link {
          a {
            display: inline-block;
						font-size: v.$font-size;
            padding: 0.5rem;
          }
        }
      }
    }
		&__copyright {
			display: inline-block;
			font-size: v.$font-size-sm;
			padding: 1rem 0.5rem;
		}
  }
</style>
